var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 32,
    viewBox: "0 0 47 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.43 8.167H1.065A1.075 1.075 0 0 1 0 7.083C0 6.485.477 6 1.065 6H18l-4.57 2.167zm-5.334 5.417H3.552A1.075 1.075 0 0 1 2.486 12.5c0-.598.477-1.083 1.066-1.083h4.901a3.71 3.71 0 0 0-.358 2.167zM10.41 19H6.038a1.075 1.075 0 0 1-1.065-1.083c0-.599.477-1.084 1.065-1.084h3.38L10.41 19z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.051 2.256 12.31 13.612l.173.365c.289.608 1.07.716 1.65.816 5.025.855 10.057 1.802 15.077 2.702 2.526-4.364 5.027-8.76 7.588-13.102.427-.723.703-1.19.427-1.773l-.173-.364zm-16.396 29.56c-.948.436-2.124.077-2.577-.875L10.171 14.25c-.45-.95.03-2.073.977-2.508L36.344.177c.947-.434 2.142-.046 2.596.913l7.89 16.653c.45.95-.03 2.073-.978 2.508L20.655 31.817zM13.896 16.96l5.394 11.386 4.422-9.63-9.59-1.719c-.16-.028-.116-.019-.226-.037zm7.48 12.123 21.888-10.047-10.696-2.955-1.827 3.156a1.11 1.11 0 0 1-1.21.521l-3.579-.64-4.576 9.965zM44.03 16.99 38.637 5.603l-.112.191-4.83 8.34 10.336 2.856z",
    fill: "#C8C8C8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.c3c306982258e543817484d9a88306f5.svg";
export { ForwardRef as ReactComponent };